module.exports = __webpack_public_path__ + "static/media/hall-P8.b32e632b.svg";